import { useTranslation } from "react-i18next";

const labelMapLang = {
  en: "labelEn",
  es: "labelEs",
  fr: "labelFr",
  it: "labelIt",
  nl: "labelNl",
};
export const getLabelInAppLanguage = () => {
      const { i18n } = useTranslation("global");
      const currentLanguageCode = i18n.language;
    
    return labelMapLang[currentLanguageCode];

}